import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    armazem: [],
    idlocalarmazenamento: null,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('resultadosecagem', { params: { ...where, ...params } }),
        apirecebimentoweb.get('resultadosecagem/count', { params: where }),
      ]);
      return { data, total };
    },

async findPessoaDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('resultadosecagem/pessoa/distinct', { params: where }),
      ]);
      return { data };
    },

    async findPessoaDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`resultadosecagem/pessoa/distinct/${codigo}`),
      ]);
      return { data };
    },

    async findPropriedadeDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('resultadosecagem/propriedade/distinct', { params: where }),
      ]);
      return { data };
    },

    async findPropriedadeDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`resultadosecagem/propriedade/distinct/${codigo}`),
      ]);
      return { data };
    },

    async findControleArmazenamento(_, {
      tipo, where, ...params
    } = {}) {
      const { data } = await apirecebimentoweb.get('resultadosecagem/controlearmazenamento', { params: { tipo, ...where, ...params } });
      return data;
    },

    async findArmazem({ commit }) {
      const { data } = await apirecebimentoweb.get('resultadosecagem/armazem');
      commit('SET_ARMAZEM', data);
      return data;
    },

  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_ARMAZEM(state, armazem) {
      state.armazem = armazem ?? [];
    },
    SET_LOCAL(state, id) {
      state.idlocalarmazenamento = id;
    }
  },
};
